export const MalformedParamException = {
  errorCode: 'BAD_REQUEST',
  errorMessage: {
    success: 'false',
    errorCode: 'INVALID_REQUEST_PARAM',
    errorMessage: 'Invalid request parameter provided',
    errorData: {},
  },
}
